<div class="sw-cms-el-config-moorl-share">
    <sw-multi-select
        :label="$tc('sw-cms.elements.moorl-share.label.provider')"
        :options="elementOptions.provider"
        v-model:value="element.config.provider.value"
    />
</div>